import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { CryptoDepositViewData } from "@modules/+new/payments/features/crypto-deposit/domain/entities/crypto-deposit-view-data";
import { Observable } from "rxjs";

const initialState: CryptoDepositViewData = null;
@Injectable()
export class CryptoDepositStateService extends StateService<CryptoDepositViewData> {
	constructor() {
		super(initialState);
	}

	public getViewData$(): Observable<CryptoDepositViewData> {
		return this.select((state: CryptoDepositViewData) => state);
	}

	public setViewData(viewData: CryptoDepositViewData): void {
		this.setState(viewData);
	}

	public isViewDataStateLoaded(): boolean {
		return !!this.state;
	}
}
